/* Raine & Co commerce pages: collection filters and paging, product page, gift card, bag page, search tabs, wishlist
   and product rails. Uses window.RC from theme.js (cart, wishlist, drawers, rails, reveal) and falls back to the
   Ajax cart directly if it is missing. Loaded with defer by the commerce sections. */
(function () {
  'use strict';
  if (window.__rcCommerce) return;
  window.__rcCommerce = true;
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  function RC() { return W.RC || {}; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var NB = ' ';
  function fmt(cents) {
    if (RC().fmt) return RC().fmt(cents);
    return 'R' + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, NB);
  }
  function svg(n) {
    if (RC().svg) return RC().svg(n);
    var P = { left: '<path d="M15 5l-7 7 7 7"/>', right: '<path d="M9 5l7 7-7 7"/>', close: '<path d="M5 5l14 14M19 5L5 19"/>', tick: '<path d="M4 12.5l5 5L20 6.5"/>', heart: '<path d="M12 20.2S3.8 15 3.8 9.3A4.4 4.4 0 0 1 12 7.2a4.4 4.4 0 0 1 8.2 2.1C20.2 15 12 20.2 12 20.2z"/>' };
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (P[n] || '') + '</svg>';
  }
  // RC.cart.add refreshes the bag and opens the drawer unless opts.open is false
  function cartAdd(items, opts) {
    if (RC().cart && RC().cart.add) return RC().cart.add(items, opts);
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; if (!opts || opts.open !== false) location.href = '/cart'; return j; }); });
  }
  function cartRefresh() { if (RC().cart && RC().cart.refresh) RC().cart.refresh(); }
  function reveal() { if (RC().initReveal) RC().initReveal(); else $$('.reveal').forEach(function (e) { e.classList.add('in'); }); }
  function wishHas(h) { return RC().wish && RC().wish.has ? RC().wish.has(h) : false; }
  function syncWish(root) {
    $$('.wish[data-id], #wish-b', root).forEach(function (b) { b.setAttribute('aria-pressed', String(wishHas(b.getAttribute('data-id')))); });
  }
  function errText(e) { return (e && ((e.data && e.data.description) || e.description || e.message)) || 'That could not be added. Please try again.'; }

  /* ---------- rails ---------- */
  function railControls(rail, prev, next) {
    if (RC().railControls) return RC().railControls(rail, prev, next);
    function step() { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 24 : 300; }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  }
  function initRails(root) {
    $$('[data-c-rail]', root).forEach(function (rail) {
      if (rail.getAttribute('data-bound')) return;
      rail.setAttribute('data-bound', '1');
      var head = rail.parentElement && rail.parentElement.previousElementSibling;
      var b = head ? $$('.rail-ctl button', head) : [];
      railControls(rail, b[0], b[1]);
    });
  }

  /* ================= COLLECTION ================= */
  function initCollection(root) {
    var PAGE = 48;
    var EDITS = ['Everyday Sparkle', 'Charm & Romance', 'Modern Essentials', 'Molten Gold', 'Pearl Revival', 'Colour Pop'];
    var CATS = ['Earrings', 'Necklaces', 'Rings', 'Bracelets', 'Anklets'];
    var BANDS = { u400: 'Under R400', b400: 'R400 to R499', o500: 'R500 and over' };
    var grid = $('#pgrid'), countEl = $('#count'), actEl = $('#activef'), pagerEl = $('#more');
    var catMode = !!root.getAttribute('data-cat');
    var items = null, client = false;
    var st = { subs: {}, cats: {}, bands: {}, edits: {}, sort: 'featured', page: Number(root.getAttribute('data-page')) || 1 };
    var etile = $('.etile', grid); var tileHtml = etile ? etile.outerHTML : '';

    function band(p) { return p.price < 40000 ? 'u400' : (p.price < 50000 ? 'b400' : 'o500'); }
    function keys(o) { return Object.keys(o); }
    function filtered() {
      var l = items.filter(function (p) {
        if (keys(st.subs).length && !st.subs[p.sub]) return false;
        if (keys(st.cats).length && !st.cats[p.type]) return false;
        if (keys(st.bands).length && !st.bands[band(p)]) return false;
        if (keys(st.edits).length && !st.edits[p.edit]) return false;
        return true;
      });
      if (st.sort === 'featured') l.sort(function (a, b) { return a.pos - b.pos; });
      if (st.sort === 'newest') l.sort(function (a, b) { return (b.created - a.created) || (a.pos - b.pos); });
      if (st.sort === 'low') l.sort(function (a, b) { return a.price - b.price || a.pos - b.pos; });
      if (st.sort === 'high') l.sort(function (a, b) { return b.price - a.price || a.pos - b.pos; });
      return l;
    }
    function drawer() {
      function cnt(fn) { return items.filter(fn).length; }
      function opt(g, k, label, n) { var on = !!st[g][k]; return '<label class="fopt"><input type="checkbox" data-g="' + g + '" data-k="' + esc(k) + '"' + (on ? ' checked' : '') + '><span class="bx">' + svg('tick') + '</span><span>' + esc(label) + '</span><span class="n">' + n + '</span></label>'; }
      function grp(title, opts) { return opts.length > 1 ? '<div class="fgroup"><h3>' + title + '</h3>' + opts.join('') + '</div>' : ''; }
      var h = '';
      if (catMode) {
        var subs = []; items.forEach(function (p) { if (p.sub && subs.indexOf(p.sub) < 0) subs.push(p.sub); });
        h += grp('Style', subs.map(function (s) { return opt('subs', s, s, cnt(function (p) { return p.sub === s; })); }));
      } else {
        h += grp('Category', CATS.map(function (c) { var n = cnt(function (p) { return p.type === c; }); return n ? opt('cats', c, c, n) : ''; }).filter(Boolean));
      }
      h += grp('Price', keys(BANDS).map(function (b) { var n = cnt(function (p) { return band(p) === b; }); return n ? opt('bands', b, BANDS[b], n) : ''; }).filter(Boolean));
      h += grp('Edit', EDITS.map(function (e) { var n = cnt(function (p) { return p.edit === e; }); return n ? opt('edits', e, e, n) : ''; }).filter(Boolean));
      $('#fdrawer-b').innerHTML = h;
      var side = $('#fside-b'); if (side) side.innerHTML = h;
      var fo = $('#f-open'); if (fo) fo.hidden = !h;
    }
    function activeTags() {
      var tags = [];
      keys(st.subs).forEach(function (k) { tags.push(['subs', k, k]); });
      keys(st.cats).forEach(function (k) { tags.push(['cats', k, k]); });
      keys(st.bands).forEach(function (k) { tags.push(['bands', k, BANDS[k]]); });
      keys(st.edits).forEach(function (k) { tags.push(['edits', k, k]); });
      actEl.innerHTML = tags.map(function (t) { return '<button type="button" data-g="' + t[0] + '" data-k="' + esc(t[1]) + '" aria-label="Remove filter ' + esc(t[2]) + '">' + esc(t[2]) + svg('close') + '</button>'; }).join('') + (tags.length > 1 ? '<button type="button" data-clear class="clr">Clear all</button>' : '');
      var fb = $('#f-open .n'); if (fb) { fb.textContent = tags.length ? tags.length : ''; fb.hidden = !tags.length; }
    }
    function pager(n) {
      var pages = Math.max(1, Math.ceil(n / PAGE)), cur = st.page, from = (cur - 1) * PAGE + 1, to = Math.min(n, cur * PAGE);
      if (!n) return '';
      var h = '<p class="pg-t">Showing ' + from + ' to ' + to + ' of ' + n + (n === 1 ? ' piece' : ' pieces') + '</p>';
      if (pages < 2) return h;
      h += '<nav class="pager" aria-label="Pages"><button type="button" class="pg-a" data-pg="' + (cur - 1) + '"' + (cur === 1 ? ' disabled' : '') + ' aria-label="Previous page">' + svg('left') + '</button>';
      for (var i = 1; i <= pages; i++) h += '<button type="button" class="pg-n" data-pg="' + i + '"' + (i === cur ? ' aria-current="page"' : '') + ' aria-label="Page ' + i + '">' + i + '</button>';
      return h + '<button type="button" class="pg-a" data-pg="' + (cur + 1) + '"' + (cur === pages ? ' disabled' : '') + ' aria-label="Next page">' + svg('right') + '</button></nav>';
    }
    function renderGrid() {
      var l = filtered(), n = l.length, pages = Math.max(1, Math.ceil(n / PAGE));
      if (st.page > pages) st.page = pages;
      var start = (st.page - 1) * PAGE, show = l.slice(start, start + PAGE), html = '';
      show.forEach(function (p, i) {
        html += p.html;
        if (st.page === 1 && i === 5 && n > 9 && tileHtml) html += tileHtml;
      });
      if (!n) html = '<div class="empty"><p>No pieces match these filters</p><button class="btn btn-ink" type="button" data-clear>Clear all filters</button></div>';
      grid.innerHTML = html;
      countEl.textContent = n + (n === 1 ? ' piece' : ' pieces');
      pagerEl.innerHTML = pager(n);
      var b = $('#f-show'); if (b) b.textContent = 'Show ' + n + (n === 1 ? ' piece' : ' pieces');
      activeTags(); syncWish(grid); reveal();
      try { var u = new URL(location.href); if (st.page > 1) u.searchParams.set('page', st.page); else u.searchParams.delete('page'); history.replaceState(null, '', u.pathname + u.search); } catch (x) { }
    }
    function clearAll() { st.subs = {}; st.cats = {}; st.bands = {}; st.edits = {}; st.page = 1; }
    function update() { client = true; drawer(); renderGrid(); }
    function toTop() { var t = $('.grid-sec'), hd = $('.site-header'); if (t) W.scrollTo(0, t.getBoundingClientRect().top + W.scrollY - ((hd ? hd.offsetHeight : 0) + 64)); }

    function load() {
      return fetch(root.getAttribute('data-cards'), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        items = $$('.c-item', doc).map(function (el) {
          return { h: el.getAttribute('data-h'), type: el.getAttribute('data-type'), sub: el.getAttribute('data-sub'), edit: el.getAttribute('data-edit'), price: Number(el.getAttribute('data-price')) || 0, created: Number(el.getAttribute('data-created')) || 0, pos: Number(el.getAttribute('data-pos')) || 0, html: el.innerHTML };
        });
        drawer();
        var fb = $('#f-show'); if (fb) fb.textContent = 'Show ' + items.length + (items.length === 1 ? ' piece' : ' pieces');
      });
    }
    var ready = load().catch(function () { items = null; });
    function whenReady(fn) { ready.then(function () { if (items) fn(); }); }

    function onFilter(e) {
      var i = e.target; if (!i.getAttribute || !i.getAttribute('data-g')) return;
      var g = i.getAttribute('data-g'), k = i.getAttribute('data-k');
      if (i.checked) st[g][k] = 1; else delete st[g][k];
      st.page = 1; update();
    }
    $('#fdrawer').addEventListener('change', onFilter);
    if ($('#fside')) $('#fside').addEventListener('change', onFilter);
    if ($('#fside-clear')) $('#fside-clear').addEventListener('click', function () { whenReady(function () { clearAll(); update(); }); });
    actEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-clear')) clearAll();
      else { delete st[b.getAttribute('data-g')][b.getAttribute('data-k')]; st.page = 1; }
      update();
    });
    grid.addEventListener('click', function (e) { if (e.target.closest('[data-clear]')) { clearAll(); update(); } });
    pagerEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pg]'); if (!b || b.disabled) return;
      st.page = Number(b.getAttribute('data-pg')); renderGrid(); toTop();
    });
    $('#sort').addEventListener('change', function () { var v = this.value; whenReady(function () { st.sort = v; st.page = 1; update(); }); });
    var fo = $('#f-open');
    fo.addEventListener('click', function () {
      var d = $('#fdrawer');
      if (RC().openDrawer) RC().openDrawer(d, fo);
      else { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); fo.setAttribute('aria-expanded', 'true'); }
    });
    function closeF() {
      var d = $('#fdrawer');
      if (RC().closeDrawer) RC().closeDrawer();
      else { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); fo.setAttribute('aria-expanded', 'false'); }
    }
    $('#f-clear').addEventListener('click', function () { whenReady(function () { clearAll(); update(); }); });
    $('#f-show').addEventListener('click', closeF);
    $$('#fdrawer [data-close]').forEach(function (b) { b.addEventListener('click', closeF); });
    var ib = $('#c-intro-b'), intro = $('#c-intro');
    if (ib && intro) {
      ib.addEventListener('click', function () { var o = intro.classList.toggle('open'); ib.setAttribute('aria-expanded', String(o)); ib.textContent = o ? 'Read less' : 'Read more'; });
      // hide Read more when the intro already fits in two lines
      var fits = function () { if (!intro.classList.contains('open')) ib.hidden = intro.scrollHeight <= intro.clientHeight + 2; };
      fits(); W.addEventListener('resize', fits, { passive: true });
    }
    syncWish(grid);
  }

  /* ================= PRODUCT ================= */
  function initProduct(root) {
    var form = $('#pf'), idInput = $('#pf-id'), qtyInput = $('#pf-qty'), msg = $('#add-msg');
    var qty = 1, handle = root.getAttribute('data-handle'), title = root.getAttribute('data-title');
    var giftVar = (RC().giftBoxVariant) || root.getAttribute('data-gift-variant');
    // gallery
    var main = $('#g-main');
    $$('.g-thumb', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-src'); main.setAttribute('srcset', t.getAttribute('data-srcset')); main.alt = t.getAttribute('data-alt') || ''; }
        $$('.g-thumb', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
      });
    });
    var tr = $('#g-track'), dots = $$('.g-dots i', root);
    if (tr && dots.length) tr.addEventListener('scroll', function () { var i = Math.round(tr.scrollLeft / tr.clientWidth); dots.forEach(function (d, j) { d.classList.toggle('on', i === j); }); }, { passive: true });
    // sizes
    $$('[data-size]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        idInput.value = b.getAttribute('data-variant');
        $$('[data-size]', root).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        var l = $('#size-l'); if (l) l.textContent = b.getAttribute('data-size');
      });
    });
    // quantity
    function setQty(n) { qty = Math.max(1, Math.min(9, n)); $('#q-n').textContent = qty; qtyInput.value = qty; }
    $('#q-m').addEventListener('click', function () { setQty(qty - 1); });
    $('#q-p').addEventListener('click', function () { setQty(qty + 1); });
    // add to bag
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (busy) return; busy = true;
      var items = [{ id: Number(idInput.value), quantity: qty }];
      var g = $('#gift');
      if (g && g.checked && giftVar) items.push({ id: Number(giftVar), quantity: qty, properties: { For: title } });
      var btns = [$('#add'), $('#sbar-add')];
      btns.forEach(function (b) { if (b) b.setAttribute('aria-busy', 'true'); });
      msg.hidden = true;
      cartAdd(items).catch(function (err) { msg.hidden = false; msg.textContent = errText(err); })
        .then(function () { busy = false; btns.forEach(function (b) { if (b) b.removeAttribute('aria-busy'); }); });
    });
    var sa = $('#sbar-add');
    if (sa) sa.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
    // wishlist
    var wb = $('#wish-b');
    function wsync() { if (wb) wb.setAttribute('aria-pressed', String(wishHas(handle))); }
    if (wb) wb.addEventListener('click', function () { if (RC().wish && RC().wish.toggle) { RC().wish.toggle(handle); wsync(); } });
    D.addEventListener('rc:wish', function () { wsync(); syncWish(D); });
    wsync();
    // accordions
    $$('.acc-b', root).forEach(function (a) {
      a.addEventListener('click', function () { var o = a.getAttribute('aria-expanded') === 'true'; a.setAttribute('aria-expanded', String(!o)); var p = $('#' + a.getAttribute('aria-controls')); if (p) p.classList.toggle('open', !o); });
    });
    // sticky bar
    var sbar = $('#sbar'), buy = $('#buy');
    function sbarUpd() { if (sbar && buy) sbar.classList.toggle('show', buy.getBoundingClientRect().bottom < 0); }
    W.addEventListener('scroll', sbarUpd, { passive: true }); sbarUpd();
    // size guide
    var sg = $('#sg-open'), dlg = $('#sg'), scrim = $('.dlg-s');
    function closeDlg() { if (!dlg) return; dlg.classList.remove('open'); if (scrim) scrim.classList.remove('open'); if (sg) sg.focus(); }
    if (sg && dlg) {
      sg.addEventListener('click', function () { dlg.classList.add('open'); if (scrim) scrim.classList.add('open'); var x = $('.x', dlg); if (x) x.focus(); });
      $$('[data-dclose]', dlg).forEach(function (b) { b.addEventListener('click', closeDlg); });
      if (scrim) scrim.addEventListener('click', closeDlg);
      D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg.classList.contains('open')) closeDlg(); });
    }
  }

  /* ================= GIFT CARD ================= */
  function initGiftCard(root) {
    var form = $('#gc-f'), out = $('#gc-ok');
    function setAmt(b) {
      var v = Number(b.getAttribute('data-v'));
      $('#gc-id').value = b.getAttribute('data-variant');
      $$('#gc-amts .pill').forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      $('#gc-amt').textContent = fmt(v); $('#gc-price').textContent = fmt(v);
      $('#gc-pf').textContent = 'or 4 interest-free payments of ' + fmt(Math.round(v / 400) * 100) + ' with Payflex';
    }
    var amts = $('#gc-amts');
    amts.addEventListener('click', function (e) { var b = e.target.closest('[data-v]'); if (b) setAmt(b); });
    amts.addEventListener('keydown', function (e) {
      var bs = $$('.pill', amts), i = bs.indexOf(D.activeElement); if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = bs[(i + 1) % bs.length];
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = bs[(i - 1 + bs.length) % bs.length];
      if (n) { e.preventDefault(); n.focus(); setAmt(n); }
    });
    var msg = $('#gc-msg'), left = $('#gc-left');
    msg.addEventListener('input', function () { left.textContent = (200 - msg.value.length) + ' characters left'; });
    $('#gc-to').addEventListener('input', function () { $('#gc-lab').textContent = this.value.trim() ? 'For ' + this.value.trim() : 'Gift card'; });
    var d = new Date(), iso = function (x) { return new Date(x.getTime() - x.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };
    var date = $('#gc-date'); date.value = iso(d); date.min = iso(d); date.max = iso(new Date(d.getTime() + 90 * 864e5));
    $('#gc-off').value = String(new Date().getTimezoneOffset());
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var to = $('#gc-to').value.trim(), em = $('#gc-em').value.trim(), from = $('#gc-from').value.trim();
      out.hidden = false;
      if (!to) { $('#gc-to').focus(); out.innerHTML = 'Add the recipient’s name so we can address the card.'; return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { $('#gc-em').focus(); out.innerHTML = 'Add a valid email address for the recipient. The gift card is sent there.'; return; }
      var text = msg.value.trim();
      if (from) { var tail = (text ? '\n\n' : '') + 'From ' + from; text = (text + tail).length > 200 ? text.slice(0, 200 - tail.length) + tail : text + tail; }
      var props = { '__shopify_send_gift_card_to_recipient': 'on', 'Recipient name': to, 'Recipient email': em, '__shopify_offset': $('#gc-off').value };
      if (text) props['Message'] = text;
      if (date.value) props['Send on'] = date.value;
      out.innerHTML = 'Adding the gift card to your bag.';
      cartAdd([{ id: Number($('#gc-id').value), quantity: 1, properties: props }], { open: false }).then(function () {
        var when = date.value ? new Date(date.value + 'T00:00:00').toLocaleDateString('en-ZA', { day: 'numeric', month: 'long', year: 'numeric' }) : 'today';
        out.innerHTML = '<div class="sp-ok">' + svg('tick') + '<div><b>' + esc($('#gc-amt').textContent) + ' gift card for ' + esc(to) + '</b><br>We will email it to ' + esc(em) + ' on ' + esc(when) + '. <a href="/checkout" style="text-decoration:underline;text-underline-offset:3px">Go to checkout</a></div></div>';
      }).catch(function (err) { out.innerHTML = esc(errText(err)); });
    });
  }

  /* ================= BAG PAGE ================= */
  function initCart(root) {
    var section = root.getAttribute('data-section'), selfAt = 0;
    function giftVar() { return RC().giftBoxVariant || root.getAttribute('data-gift-variant'); }
    function rerender() {
      return fetch('/cart?section_id=' + encodeURIComponent(section), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html'), fresh = $('#cart-root', doc);
        if (fresh) { var y = W.scrollY; root.innerHTML = fresh.innerHTML; initRails(root); syncWish(root); reveal(); W.scrollTo(0, y); }
      });
    }
    function post(url, body) {
      selfAt = Date.now();
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); }).then(function () { return rerender(); }).then(function () { cartRefresh(); });
    }
    root.addEventListener('click', function (e) {
      var q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]'), u = {};
      if (q) {
        var n = Math.max(0, Number(q.getAttribute('data-n')) + Number(q.getAttribute('data-q')));
        u[q.getAttribute('data-key')] = n; if (q.getAttribute('data-gkey')) u[q.getAttribute('data-gkey')] = n;
        post('/cart/update.js', { updates: u });
      }
      if (rm) {
        u[rm.getAttribute('data-rm')] = 0; if (rm.getAttribute('data-gkey')) u[rm.getAttribute('data-gkey')] = 0;
        post('/cart/update.js', { updates: u });
      }
    });
    root.addEventListener('change', function (e) {
      var c = e.target; if (!c.hasAttribute || !c.hasAttribute('data-gift-for')) return;
      if (c.checked && giftVar()) {
        selfAt = Date.now();
        cartAdd([{ id: Number(giftVar()), quantity: Number(c.getAttribute('data-n')) || 1, properties: { For: c.getAttribute('data-gift-for') } }], { open: false }).then(rerender);
      } else if (c.getAttribute('data-gkey')) {
        var u = {}; u[c.getAttribute('data-gkey')] = 0; post('/cart/update.js', { updates: u });
      }
    });
    D.addEventListener('rc:cart', function () { if (Date.now() - selfAt > 2000) rerender(); });
  }

  /* ================= SEARCH ================= */
  function initSearch(root) {
    var gridEl = $('#sr-grid', root), tabs = $('#sr-tabs', root); if (!gridEl || !tabs) return;
    var its = $$('.sr-item', gridEl), types = [];
    its.forEach(function (i) { var t = i.getAttribute('data-type'); if (t && types.indexOf(t) < 0) types.push(t); });
    if (types.length < 2) return;
    var cur = 'All';
    function draw() {
      tabs.innerHTML = ['All'].concat(types).map(function (c) { var n = c === 'All' ? its.length : its.filter(function (i) { return i.getAttribute('data-type') === c; }).length; return '<button type="button" data-c="' + esc(c) + '" aria-pressed="' + (c === cur) + '">' + esc(c) + ' (' + n + ')</button>'; }).join('');
      its.forEach(function (i) { i.hidden = cur !== 'All' && i.getAttribute('data-type') !== cur; });
    }
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; cur = b.getAttribute('data-c'); draw(); });
    draw();
  }

  /* ================= WISHLIST ================= */
  function initWishlist(root) {
    var empty = $('#wl-empty', root), emptyHtml = empty ? empty.outerHTML : '';
    function list() { return RC().wish && RC().wish.list ? RC().wish.list() : []; }
    function draw() {
      var hs = list().slice(), cnt = $('#wl-count');
      if (!hs.length) { root.innerHTML = emptyHtml; if (cnt) cnt.textContent = ''; return; }
      Promise.all(hs.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=card', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (res) {
        var cards = res.map(function (t) { if (!t) return null; var doc = new DOMParser().parseFromString(t, 'text/html'); return $('.wl-item', doc); }).filter(Boolean);
        if (cnt) cnt.textContent = cards.length ? cards.length + (cards.length === 1 ? ' saved piece.' : ' saved pieces.') : '';
        if (!cards.length) { root.innerHTML = emptyHtml; return; }
        root.innerHTML = '<div class="pgrid">' + cards.map(function (c) {
          var h = c.getAttribute('data-h'), sized = c.getAttribute('data-sized') === 'true', avail = c.getAttribute('data-available') === 'true';
          var act = !avail ? '<span class="btn btn-line" aria-disabled="true">Sold out</span>' : (sized ? '<a class="btn btn-line" href="/products/' + esc(h) + '">Choose a ring size</a>' : '<button class="btn btn-ink" type="button" data-add="' + esc(c.getAttribute('data-variant')) + '">Add to bag</button>');
          return '<div>' + c.innerHTML + '<div class="wl-act">' + act + '</div></div>';
        }).join('') + '</div><div class="cta-row"><a class="btn btn-ink" href="/cart">View bag</a><a class="btn btn-line" href="/collections/all">Keep shopping</a></div>';
        syncWish(root); reveal();
      });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-add]'); if (!b) return;
      cartAdd([{ id: Number(b.getAttribute('data-add')), quantity: 1 }]);
    });
    D.addEventListener('rc:wish', draw);
    draw();
  }

  function boot() {
    initRails(D);
    var c = $('#c-root'); if (c) initCollection(c);
    var p = $('[data-c-product]'); if (p) initProduct(p);
    var g = $('[data-c-giftcard]'); if (g) initGiftCard(g);
    var k = $('[data-c-cart]'); if (k) initCart(k);
    var s = $('[data-c-search]'); if (s) initSearch(s);
    var w = $('[data-c-wishlist]'); if (w) initWishlist(w);
    syncWish(D);
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
